import { api } from "@/lib/api";

export type UserMe = {
  id: string;
  name: string;
  surname: string | null;
  email: string;
  dni: string | null;
  address: string | null;
  phone: string | null;
  avatar_thumb_url: string | null;
  avatar_profile_url: string | null;
  avatar_updated_at: string | null;
  location_policy: "OFF" | "REQUIRED" | "OPTIONAL" | string;
  location_required_events: string[];
};

export type ProfileUpdateInput = {
  name: string;
  surname: string | null;
  dni: string | null;
  address: string | null;
  phone: string | null;
};

export async function fetchMe(): Promise<UserMe> {
  const { data } = await api.get<UserMe>("/api/v1/users/me");
  return data;
}

export async function updateProfile(payload: ProfileUpdateInput): Promise<UserMe> {
  const { data } = await api.patch<UserMe>("/api/web/profile", payload);
  return data;
}

export type AvatarPresignResponse = {
  upload: { url: string; fields: Record<string, string> | null };
  object_key: string;
  expires_in: number;
};

export async function presignAvatar(file: File): Promise<AvatarPresignResponse> {
  const { data } = await api.post<AvatarPresignResponse>(
    "/api/v1/users/me/avatar/presign",
    {
      filename: file.name,
      content_type: file.type,
      size_bytes: file.size,
    },
  );
  return data;
}

export async function uploadAvatarToS3(
  presign: AvatarPresignResponse,
  file: File,
): Promise<void> {
  const { url, fields } = presign.upload;
  if (fields && Object.keys(fields).length > 0) {
    // POST multipart (S3 form upload)
    const fd = new FormData();
    for (const [k, v] of Object.entries(fields)) fd.append(k, v);
    fd.append("file", file);
    const res = await fetch(url, { method: "POST", body: fd });
    if (!res.ok) throw new Error(`S3 upload failed (${res.status})`);
  } else {
    // PUT direct
    const res = await fetch(url, {
      method: "PUT",
      headers: file.type ? { "Content-Type": file.type } : undefined,
      body: file,
    });
    if (!res.ok) throw new Error(`S3 upload failed (${res.status})`);
  }
}

export type AvatarCompleteResponse = {
  avatar_thumb_url: string | null;
  avatar_profile_url: string | null;
  avatar_updated_at: string;
};

export async function completeAvatar(
  object_key: string,
): Promise<AvatarCompleteResponse> {
  const { data } = await api.post<AvatarCompleteResponse>(
    "/api/v1/users/me/avatar/complete",
    { object_key },
  );
  return data;
}
